"use strict";

import ReactDOM from "react-dom";
import React, { useState, useEffect } from "react";

const axios = require("axios");

const Votes = (props) => {
  const [states, setStates] = useState([]);

  const [votes, setVotes] = useState();

  const [mapData, setMapData] = useState({
    totalBoxText: "",
    hover: false,
    year: "2024",
  });

  const [totalVotes, setTotalVotes] = useState({
    seats_democratic: 0,
    seats_republican: 0,
    seats_other: 0,
  });

  let stringtest = props.role
    .replace(/\s+/g, "_")
    .replace(/\.+/g, "")
    .toLowerCase()
    .replace("secretary_of_state", "secretary")
    .replace("the_house_of_representatives", "house")
    .replace("the_electoral_college", "electoral_college")
    .replace("the_senate", "senate");

  useEffect(() => {
    let totalText;
    switch (stringtest) {
      case "electoral_college":
        totalText = "Total Electoral Votes";
        break;
      case "senate":
        totalText = `Senate Seats Up In ${mapData.year}`;
        break;
      case "house":
        totalText = `House Seats Up In ${mapData.year}`;
        break;
      default:
        totalText = `Elections In ${mapData.year}`;
    }

    setMapData({
      ...mapData,
      hover: stringtest === "house" ? true : false,
      totalBoxText: totalText,
    });

    const populateData = async () => {
      const wp_data = await axios.get(
        "https://allintovote.staging.wpengine.com/wp-json/wp/v2/states",
        { params: { per_page: 60 } }
      );

      const stateKeys = [
        "name",
        "abbreviation",
        "electoral_college",
        "senate",
        "house",
        "governor",
        "secretary",
        "attorney_general",
      ];

      let stateData = [];
      let totalDem = 0;
      let totalRep = 0;
      let totalOther = 0;
      wp_data.data.forEach((element) => {
        // Filter through each state api return and select only the keys we want from the stateKeys array
        const stateObject = Object.keys(element.acf)
          .filter((k) => stateKeys.includes(k))
          .map((k) => Object.assign({}, { [k]: element.acf[k] }))
          .reduce((res, o) => Object.assign(res, o), {});

        if (stateObject[stringtest] && stateObject[stringtest].open) {
          if (stringtest === "house") {
            totalDem += +stateObject[stringtest].seats_democratic;
            totalRep += +stateObject[stringtest].seats_republican;
            totalOther += +stateObject[stringtest].seats_other;
          } else {
            stateObject[stringtest].party === "democrat"
              ? ++totalDem
              : ++totalRep;
          }
        }
        stateData.push(stateObject);
      });

      setTotalVotes({
        ...totalVotes,
        seats_democratic: totalDem,
        seats_republican: totalRep,
        seats_other: totalOther,
      });

      setStates(stateData);
    };
    populateData();
  }, []);

  function showDetails(state) {
    setVotes(state);
  }

  return (
    <>
      <div className="election__data">
        <div className="election__data--entry election__data--total">
          <span className="election__data--title">
            {stringtest === "house" && votes ? votes.name + " " : null}
            {mapData.totalBoxText}
          </span>
          <span className="election__data--amount">
            {votes
              ? +votes[stringtest].seats_democratic +
                +votes[stringtest].seats_republican
              : totalVotes.seats_democratic + totalVotes.seats_republican}
          </span>
        </div>

        {stringtest !== "electoral_college" && (
          <>
            <div className="election__data--entry election__data--dem">
              <span className="election__data--title">Currently Democrat</span>
              <span className="election__data--amount">
                {votes
                  ? votes[stringtest].seats_democratic
                  : totalVotes.seats_democratic}
              </span>
            </div>

            <div className="election__data--entry election__data--rep">
              <span className="election__data--title">
                Currently Republican
              </span>
              <span className="election__data--amount">
                {votes
                  ? votes[stringtest].seats_republican
                  : totalVotes.seats_republican}
              </span>
            </div>
          </>
        )}

        {stringtest === "house" && (
          <div className="election__data--entry election__data--other">
            <span className="election__data--title">Currently Other</span>
            <span className="election__data--amount">
              {votes
                ? votes[stringtest].seats_other
                  ? votes[stringtest].seats_other
                  : 0
                : totalVotes.seats_other}
            </span>
          </div>
        )}

        {stringtest === "electoral_college" && (
          <div className="election__data--entry election__data--needed">
            <span className="election__data--title">Needed to Win</span>
            <span className="election__data--amount">270</span>
          </div>
        )}
      </div>

      <div className="state-grid">
        {states.map((value, index) => {
          return (
            <span
              key={index}
              onMouseOver={() => (mapData.hover ? showDetails(value) : null)}
              onMouseLeave={() => showDetails(null)}
              className={
                "election-state " +
                (value.abbreviation ? value.abbreviation.toLowerCase() : "") +
                (value[stringtest].open
                  ? " election-state--" + value[stringtest].party
                  : "")
              }
            >
              {value[stringtest].open ? value.abbreviation : ""}
            </span>
          );
        })}
      </div>
    </>
  );
};

const maps = document.getElementsByClassName("election__map");
for (var map of maps) {
  const role = map.dataset.role;
  ReactDOM.render(<Votes role={role} />, map);
}
